<div class="content-wrapper w-full h-full">
  <div class="form-container ">
    <div class="col-sm-8 col-sm-offset-2 col-lg-10 col-lg-offset-1 mx-auto form-wrapper" style="display: inline-block;">
      <form #login="ngForm" name="getrecordings" (ngSubmit)="searchClicked()" class="search-recordings-form">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-4">
            <div class="form-group">
              <input class="form-control" placeholder="Exam ID" required type="text" name="examid" [(ngModel)]="examid">
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-4">
            <div class="form-group">
              <input class="form-control" placeholder="Candidate Number" type="text" required name="candidateno"
                [(ngModel)]="candidateno">
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-2 text-center">
            <button type="submit" class="btn btn-primary form-control" [disabled]="!filled()">Search</button>
          </div>
          <div *ngIf="this.secondViewRecordings?.length > 0" class="col-sm-12 col-md-12 col-lg-2 synchronize-control-div">
            <label for="synchronizevideos">Synchronize</label>
            <input name="synchronizevideos" id="synchronizevideos" type="checkbox" [(ngModel)]="this._synchronizeVideos">
          </div>
        </div>
      </form>
    </div>
    <!-- <app-logout></app-logout> -->
  </div>

  <div id="video-lists-container">
    <div id="candidates_list_div"
      [ngStyle]="{visibility: !this.candidateNos || this.candidateNos.length == 0 ? 'hidden' : 'unset'}">
      <div *ngFor="let _candidateno of candidateNos"><button class=" btn mb-1 candidate-button"
          [ngClass]="{'btn-info': _candidateno != this.candidateno, 'btn-success': _candidateno == this.candidateno}"
          (click)="loadCandidateData(this.examid,  _candidateno)">{{_candidateno}}</button></div>
    </div>
    
    <div id="main_data_div">
      <div id="passport_and_videos_grid_div">
        <div [hidden]="!this.passportPhotoUrl" id="passport_photo_div">
          <img class="bg-black text-white" src="{{passportPhotoUrl}}" alt="Passport Photo">
        </div>
        <div id="videos_grid_div">
          <div id="video_primary_view_table_div">
              <table *ngIf="this.primaryViewRecordings.length > 0 else noCandidateVideosFound;" class="proctor-monitor-table">
                <thead>
                  <tr>
                    <th colspan="4">Primary View Video Recordings</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let recording of primaryViewRecordings; let i = index">
                    <th scope="row">{{i + 1}}</th>
                    <td>{{recording.datetimestring}}</td>
                    <td class="play-video-td">
                      <button (click)="loadExamVideo(recording.time, false, true, true, true)" class="play-video">
                        <i class="fa fa-play"></i>
                      </button>
                    </td>
                    <td class="download-video-td">
                      <a (click)="downloadVideo(recording.time, false)" class="download-video"><i class="fa fa-download"></i></a>
                    </td>

                  </tr>
                </tbody>
              </table>
          </div>
          <div id="video_second_view_table_div">
              <table *ngIf="this.secondViewRecordings.length > 0 else noCandidateVideosFound;" class="proctor-monitor-table">
                <thead>
                  <tr>
                    <th colspan="4">Secondary View Video Recordings</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let recording of secondViewRecordings; let i = index">
                    <th scope="row">{{i + 1}}</th>
                    <td>{{recording.datetimestring}}</td>
                    <td class="play-video-td">
                      <button [disabled]="this.synchronizeVideos" (click)="loadExamVideo(recording.time, true, true, true, true)" class="play-video">
                        <i class="fa fa-play"></i>
                      </button>
                    </td>
                    <td class="download-video-td">
                      <a (click)="downloadVideo(recording.time, true)" class="download-video"><i class="fa fa-download"></i></a>
                    </td>

                  </tr>
                </tbody>
              </table>
          </div>
        </div>
      </div>
      <div id="videos-container">
        <div [style.opacity]="this.primaryViewVideoUrl ? '1' : '0'" id="primary-video-container">
          <div><h6>Primary View Video</h6></div>
          <video controls playsinline #primaryViewVideo id="primary-view-video"></video>
        </div>
        <div [style.opacity]="this.secondViewVideoUrl ? '1' : '0'" id="second-view-video-container">
          <div><h6>Secondary View Video</h6></div>
          <video controls playsinline #secondViewVideo id="second-view-video"></video>
        </div>
      </div>
      <!-- <div *ngIf="this.synchronizeVideos && this.primaryViewVideoUrl && this.secondViewVideoUrl" id="sychronized-seeker-div">
        <input type="range" id="synchronized-seeker" [attr.min]="0" #synchronizedSeeker [attr.max]="this.primaryViewVideoDuration">
      </div> -->
    </div>
    <ng-template #noCandidateVideosFound>
      <div *ngIf="this.candidateno && isCandidateSelected && !this.loadingCandidateVideoList" id="no-candidate-video-div">No videos
        found for {{this.candidateno}}</div>
    </ng-template>
  </div>
  
</div>